import { FormTemplate, TextInput } from 'ui-builder';
import { CopyPlanRequest, Plan, usePlansService } from 'nekst-api';
import { FormText, Separator } from 'features/nekst-widgets';
import React from 'react';
import { TeamSetupAreaIdDropdown } from '../../Shared';

export interface CopyPlanFormProps {
  plan: Plan
  afterSubmitFunc?: (_data: Plan) => Promise<void>,
}

export function CopyPlanForm(props: CopyPlanFormProps) {
  const planService = usePlansService();

  const afterSubmitFunc = async (data: Plan) => {
    props.afterSubmitFunc?.(data);
  };

  const defaultSetupAreaId = props.plan._setupArea?.id || undefined;

  return (
    <FormTemplate<CopyPlanRequest, Plan>
      title="Copy"
      validationSchema={{
        setupAreaId: {
          type: 'int',
          constraints: {
            required: true,
          },
        },
        name: {
          type: 'string',
          constraints: {
            required: true,
          },
        },
      }}
      submitFormFunc={async (data) => {
        return planService.copy(props.plan.id, data.name, data.setupAreaId);
      }}
      initialData={{
        setupAreaId: defaultSetupAreaId || undefined,
      }}
      afterSubmitFunc={afterSubmitFunc}
    >
      <FormText>
        Enter a new workflow name.
      </FormText>
      <Separator />
      <TeamSetupAreaIdDropdown source="setupAreaId" defaultValue={defaultSetupAreaId} />
      <TextInput source="name" label="Workflow name" />
    </FormTemplate>
  );
}
